/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '@root/components/Input';
import Button from '@root/components/Button';
import Icon from '@root/components/Icon';
import LanguageSelector from './LanguageSelector';
import accountLogo from '@root/assets/accountLogo.png';
import useLogin from '@root/hooks/login/useLogin';
import useSelectCountry from '@root/hooks/login/useSelectCountry';
import './style.less';

const Login = () => {
  const { t } = useTranslation();
  const {
    lang,
    username,
    password,
    signing,
    errorInfo,
    onClickTerms,
    onLogin,
    onSelectLang,
    onChangeUsername,
    onBlurUsername,
    onChangePassword,
  } = useLogin();
  const { countryName, onClickCountry } = useSelectCountry();

  const disabled = !!errorInfo || !(countryName && password && username);

  return (
    <div className="login-container">
      <div className="logo">
        <img src={accountLogo} />
      </div>
      <p className="login-tip">{t('payment_description')}</p>
      <div className="login-container-form">
        <div className="form-cell" onClick={onClickCountry}>
          <Icon type="location" fontSize={20} />
          <div className="form-cell-input country">
            <span className={countryName ? '' : 'placeholder'}>
              {countryName ? countryName : t('country')}
            </span>
          </div>
          <Icon className="neuter600" type="arrow-right" />
        </div>
        <div className="form-cell">
          <Icon type="email" />
          <Input
            className="form-cell-input"
            value={username || ''}
            onChange={onChangeUsername}
            onBlur={onBlurUsername}
            placeholder={t('email_placeHolder')}
            clear
          />
        </div>
        <div className="form-cell">
          <Icon type="password" fontSize={20} />
          <Input
            className="form-cell-input"
            type="password"
            value={password}
            onChange={onChangePassword}
            eye
            placeholder={t('password_placeHolder')}
          />
        </div>
        <Button onClick={onLogin} disabled={disabled} loading={signing}>
          {t('sign_in')}
        </Button>
        <div className="error-info">{errorInfo}</div>
      </div>
      <div className="login-container-footer">
        <div>
          <LanguageSelector onSelect={onSelectLang} language={lang} />
        </div>
        <span className="terms" onClick={onClickTerms}>
          {t('supplemental_terms')}
        </span>
      </div>
    </div>
  );
};

export default Login;
